import React from 'react';
import { FormLabel } from 'react-bootstrap';
import DefaultTableFilter from './DefaultTableFilter';
import DateInput from '../../Form/DateInput';
import moment from '../../../moment';
import { Column, FilterFnOption } from '@tanstack/react-table';

function IsBeforeFilter({ column, label }: { column: Column<any>; label: string }) {
	const filterValue = column.getFilterValue() as string;
	const filterValueMoment = filterValue ? moment(filterValue) : null;
	const displayValue = moment.isMoment(filterValueMoment)
		? filterValueMoment.format('DD-MM-YYYY')
		: filterValue;
	return (
		<DefaultTableFilter id={column.id} active={!!column.getFilterValue()}>
			<div className="form-group">
				<FormLabel>{label}</FormLabel>
				<DateInput
					onChange={(newStart: moment.Moment) => {
						if (moment.isMoment(newStart)) {
							column.setFilterValue(newStart.format());
						} else {
							column.setFilterValue(newStart);
						}
					}}
					value={displayValue}
					placeholder={undefined}
					prependLabel={undefined}
					minDate={undefined}
				/>
			</div>
		</DefaultTableFilter>
	);
}

export const isBeforeFilter: FilterFnOption<any> = (row, columnId, filterValue): boolean => {
	if (filterValue && moment.isMoment(moment(filterValue))) {
		const rowValue = row.getValue(columnId);
		if (!rowValue) {
			return false;
		}
		return moment(rowValue).isBefore(moment(filterValue).startOf('day'));
	}
	return true;
};
export default IsBeforeFilter;
